import {createStore} from 'redux';

import {combineReducers, applyMiddleware} from "redux";
import thunkMiddleware from 'redux-thunk'
//import * as globalActions from "./actions/globalActions";
//import {activePageReducer, activeSubpageReducer, pageStateReducer, tempDataReducer} from "./reducers/PageReducers";
import {fetchReducer/*, modalReducer, consoleReducer, animationReducer, audioReducer, unitReducer*/} from "./reducers/globalReducers";
import {updateDataReducer} from "./reducers/updateDataReducers";
//import {createContentReducer} from "./reducers/userContentReducers";
//import {searchReducer} from "./reducers/searchReducers";
//import {uploadReducer} from "./reducers/serverReducers";
//import {exploreReducer} from "./reducers/exploreReducers";
//import {userSettingsReducer} from "./reducers/userSettingsReducer";

/*
const rootReducer = (state, action) =>
{
	if(action.type == globalActions.k_clearAllState)
	{
		state = undefined;
	}
	return sliceReducers(state, action);
}
*/

const rootReducer = combineReducers
(
	{
		//activePages: activePageReducer,
		//pageStates: pageStateReducer,
		data: updateDataReducer,
		currentlyFetching: fetchReducer,
		//userContent: createContentReducer,
		//tempData: tempDataReducer,
		//log:consoleReducer,
		//search:searchReducer,
		//unit: unitReducer,
		//upload:uploadReducer,
		//explore: exploreReducer,
		//userSettings: userSettingsReducer,
	}
)



export default createStore(rootReducer, applyMiddleware(thunkMiddleware));




// WEBPACK FOOTER //
// ./js/stateStuff/store.js